module.exports = __webpack_public_path__ + "img/googlepay_logo-min.ba156dd6.png";